import {
  pushOpenAccountModalShowEvent,
  pushOpenAccountModalCloseEvent,
} from '@components-shared/googleAnalyticsEvents';
import { getClientSourceType } from '@components-shared/utils/getClientSourceType';
import type { IUser } from 'global.interfaces';

class OpenAccountAnalyticsService {
  private getOpenAccountModalData = (userInfo: IUser) => {
    const { profile, idHash } = userInfo;
    const { clientSourceType, status } = profile;

    return {
      userIdHash: idHash,
      clientSourceType,
      verification: status,
    };
  };

  openAccountModalShowEvent = (user: IUser) => {
    const { userIdHash, clientSourceType, verification } = this.getOpenAccountModalData(user);

    pushOpenAccountModalShowEvent(userIdHash, getClientSourceType(clientSourceType), verification);
  };

  openAccountModalCloseEvent = (user: IUser): void => {
    const { userIdHash, clientSourceType, verification } = this.getOpenAccountModalData(user);

    pushOpenAccountModalCloseEvent(userIdHash, getClientSourceType(clientSourceType), verification);
  };
}

export const openAccountAnalyticsService = new OpenAccountAnalyticsService();
